import { render, staticRenderFns } from "./myPoint.vue?vue&type=template&id=8d52912e&"
import script from "./myPoint.vue?vue&type=script&lang=js&"
export * from "./myPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports